import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { toast } from "react-toastify";
import { reduxForm } from 'redux-form';
import PlaidControl from './../../../components/PlaidControl';
import { integratePlaid, getPlaidAccounts, resetFlags } from '../../../redux/actions/AccountAction';

const ConnectBankAccount = ({
  nextStep,
  prevStep,
  active,
  integratePlaid,
  getPlaidAccounts,
  resetFlags,
  accountErrors,
  accountFlags,
  investAccount,
}) => {
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (accountErrors && accountErrors.integratePlaid) {
      toast.error(accountErrors.integratePlaid);
      setProcessing(false);
      resetFlags();
    }

    if (accountFlags && accountFlags.integratePlaidSuccess) {
      resetFlags();
      setProcessing(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountErrors, accountFlags]);

  const handleOnSuccess = (token, metadata) => {
    const payload = {
      public_token: token,
      bank_name: metadata.institution.name,
      invest_account_id: investAccount.id,
    }
    setProcessing(true);
    integratePlaid(payload, onConnectSuccess);
  }

  const onConnectSuccess = () => {
    getPlaidAccounts({ id: investAccount.id }, onGetAccountsSuccess);
  }

  const onGetAccountsSuccess = () => {
    setProcessing(false);
    nextStep();
  };

  const handleOnExit = () => {
    // handle the case when your user exits Link
  }

  const handleBack = () => {
    prevStep();
  }

  return (
    <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
      <div className="form-container">
        <div className="back-btn">
          <Button color="link" onClick={handleBack}>back</Button>
        </div>
        <div className="form-header mt-md-3 mt-0">
          <h2>FUND YOUR ACCOUNT</h2>
          <span>Connect an external bank account to fund your account</span>
        </div>

        <div className="button_wrapper plaid_wrapper">
          <PlaidControl
            onExit={handleOnExit}
            onSuccess={handleOnSuccess}
            processing={processing}
            title="LINK A BANK ACCOUNT"
          />
        </div>

        <div className="links-forgot" style={{ color: '#999', fontWeight: 600, fontSize: '12px' }}>
          <span>
            Myra, Inc. ("MYRA") uses Plaid Inc. ("Plaid") to gather End User’s data from financial
            institutions. By using our service, you grant MYRA and Plaid the right, power,
            and authority to act on your behalf to access and transmit your personal and
            financial information from the relevant financial institution.
            You agree to your personal and financial information being transferred, stored,
            and processed by Plaid in accordance with the &nbsp;
            <a
              style={{ fontSize: '12px' }}
              rel="noopener noreferrer"
              target="_blank"
              href="https://plaid.com/legal">Plaid Privacy Policy</a>.
          </span>
        </div>
      </div>
    </div >
  )
};

const mapStateToProps = state => ({
  accountErrors: state.Account.errors,
  accountFlags: state.Account.flags,
  investAccount: state.Account.investAccount,
});

const mapDispatchToProps = dispatch => ({
  integratePlaid: (payload, callback) => {
    dispatch(integratePlaid(payload, callback))
  },
  getPlaidAccounts: (payload, callback) => {
    dispatch(getPlaidAccounts(payload, callback))
  },
  resetFlags: payload => {
    dispatch(resetFlags())
  }
});

const ConnectBankAccountComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectBankAccount);

export default reduxForm({
  form: 'ConnectBankAccountForm',
})(ConnectBankAccountComponent);
